import { createSelector } from "reselect";

export const tracksSelector = createSelector(
    state => state.tracker.entries,
    state => state
);

export const initTrackerModuleSelector = createSelector(
    state => state.tracker.entries.isLoadingTrackerModule,
    state => state
);

export const trackerSelectedTasksSelector = createSelector(
    state => state.tracker.entries.selectedTasks,
    state => state
);

export const trackerEditMessageDialogSelector = createSelector(
    state => state.tracker.entries.editMessageDialog,
    state => state
);

export const backDropLoaderSelector = (state) => state.tracker.entries.isBackDropLoader;
